import { FC, memo } from 'react';
import s from './WarningModal.module.css';
import { Modal } from 'components/common/Modal/Modal';
import { PortalComponent } from 'components/common/PortalComponent/PortalComponent';
import { Button } from '../Button/Button';
import { useTranslation } from 'react-i18next';

export type WarningModalProps = {
  className?: string;
  title: string;
  message: string;
  onClose?: React.MouseEventHandler<HTMLElement>;
  confirmLabel: string;
  onConfirm: React.MouseEventHandler<HTMLButtonElement>;
};

export const WarningModal: FC<WarningModalProps> = memo(
  ({ className, title, message, onClose, confirmLabel, onConfirm }) => {
    const { t } = useTranslation();
    return (
      <PortalComponent>
        <Modal title={title} className={className ?? ''} onClose={onClose}>
          <div className={s.message}>{message}</div>

          <div className={s.btns}>
            <Button onClick={onClose} isAccent isRounded>
              {t('common.cancel')}
            </Button>

            <Button className={s['btn-confirm']} onClick={onConfirm} isRounded>
              {confirmLabel}
            </Button>
          </div>
        </Modal>
      </PortalComponent>
    );
  },
);

WarningModal.displayName = 'WarningModal';
